export const normalizeRsplCode = (value) => String(value || "").trim().toUpperCase();

export const parseRsplList = (value, fallback = []) => {
	if (!value) return Array.isArray(fallback) ? fallback : [];
	const parsed = Array.isArray(value)
		? value
		: (() => {
			try {
				return JSON.parse(value);
			} catch {
				return null;
			}
		})();
	if (!Array.isArray(parsed)) return Array.isArray(fallback) ? fallback : [];
	const sanitized = parsed.filter(
		(item) =>
			item &&
			typeof item.value === "string" &&
			Array.isArray(item.key) &&
			item.key.every((entry) => typeof entry === "string")
	);
	return sanitized.length > 0 ? sanitized : (Array.isArray(fallback) ? fallback : []);
};

export const buildRsplCodeToLabelMap = (rsplList = []) => {
	const map = {};
	(rsplList || []).forEach(({ key, value }) => {
		(key || []).forEach((rawCode) => {
			const code = normalizeRsplCode(rawCode);
			if (!code) return;
			map[code] = value;
		});
	});
	return map;
};

export const getRsplLabelForCode = (rawCode, codeToLabelMap = {}, fallbackLabel = "Other") => {
	const code = normalizeRsplCode(rawCode);
	if (!code) return fallbackLabel;
	return codeToLabelMap[code] || fallbackLabel;
};

